/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Trained_For_Gt2yInputs */

const en_us2_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More than 2 years`)
};

const pt_br2_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 2 anos`)
};

const es_419_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 2 años`)
};

const pt_pt2_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 2 anos`)
};

const fr_fr2_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de 2 ans`)
};

const de_de2_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr als 2 Jahre`)
};

const it_it2_onboarding_experience_trained_for_gt2y = /** @type {(inputs: Onboarding_Experience_Trained_For_Gt2yInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più di 2 anni`)
};

/**
* | output |
* | --- |
* | "More than 2 years" |
*
* @param {Onboarding_Experience_Trained_For_Gt2yInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_trained_for_gt2y = /** @type {((inputs?: Onboarding_Experience_Trained_For_Gt2yInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Trained_For_Gt2yInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_trained_for_gt2y(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_trained_for_gt2y(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_trained_for_gt2y(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_trained_for_gt2y(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_trained_for_gt2y(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_trained_for_gt2y(inputs)
	return en_us2_onboarding_experience_trained_for_gt2y(inputs)
});
export { onboarding_experience_trained_for_gt2y as "onboarding.experience_trained_for.gt2y" }